<template>
  <div
    class="IncrementInput"
    :class="{ disabled }"
    :value="value"
    @input="$emit('input', curr)">
    <div
      class="btn cta2 left"
      @click="decr()">
      -
    </div>
    <input
      v-model="curr"
      type="number"
      :disabled="disabled"
      min="0"
      @input="$emit('input', curr)">
    <div
      class="btn cta2 right"
      @click="incr()">
      +
    </div>
  </div>
</template>

<script>
export default {
  props: {
    value: {
      type: Number,
      default: 0,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },

  data: function () {
    return {
      curr: this.value,
    };
  },

  watch: {
    curr: function (val) {
      this.$emit("change", val);
    },
  },

  methods: {
    incr() {
      if (this.disabled) {
        return;
      }
      this.curr = parseInt(this.curr);
      this.curr += 1;
      this.$emit("input", this.curr);
    },

    decr() {
      if (this.disabled) {
        return;
      }
      this.curr = parseInt(this.curr);
      this.curr -= 1;
      this.$emit("input", this.curr);
    },
  },
};
</script>

<style lang="scss" scoped>
.IncrementInput {
  display: flex;

  &.disabled {
    opacity: 0.25;
  }

  .btn {
    width: 1em;
    text-align: center;
    font-size: 3em;
    padding: 0;
    margin: 0;
    line-height: 1;
    font-weight: normal;

    &.left {
      border-bottom-right-radius: 0;
      border-top-right-radius: 0;
    }
    &.right {
      border-bottom-left-radius: 0;
      border-top-left-radius: 0;
    }
  }

  input[type="number"]::-webkit-outer-spin-button,
  input[type="number"]::-webkit-inner-spin-button {
    appearance: none;
    margin: 0;
  }
  input[type="number"] {
    -moz-appearance: textfield;
  }
  input {
    flex: auto;
    width: 4em;
    border-radius: 0;
    appearance: none;
    padding-left: 1em;
    border: solid 1px var(--pale-grey);
  }
}
</style>
